import { AlarmData } from '@/slices/types';

export const turbinesTabs = [
  { id: 'summary', label: 'Summary' },
  { id: 'control', label: 'Control' },
  { id: 'generator', label: 'Generator' },
  { id: 'turbine', label: 'Turbine' },
  { id: 'vibrationBearings', label: 'Vibration/Bearings' },
  { id: 'lube', label: 'Lube' },
  { id: 'enclosure', label: 'Enclosure' },
  { id: 'alarms', label: 'Alarms' },
  { id: 'alarmSubscription', label: 'Alarm Subscriptions' }
];

export const ALARM_TYPES = {
  ALERT: 'Alert' as const,
  WARNING: 'Warning' as const
} as const;

export type AlarmType = (typeof ALARM_TYPES)[keyof typeof ALARM_TYPES];

export const ALERT_TYPE_VALUES = ['alert', 'critical', 'shutdown'] as const;

export const WARNING_TYPE_VALUES = ['warning'] as const;

export const ALERT_SEVERITY_VALUES = ['critical', 'high'] as const;

export const ALARM_TYPE_ORDER = {
  [ALARM_TYPES.ALERT]: 0,
  [ALARM_TYPES.WARNING]: 1
} as const;

export const determineAlarmType = (alarm: any): AlarmType => {
  if (alarm.type) {
    const typeStr = String(alarm.type).toLowerCase();
    if (ALERT_TYPE_VALUES.includes(typeStr as any)) {
      return ALARM_TYPES.ALERT;
    }
    if (WARNING_TYPE_VALUES.includes(typeStr as any)) {
      return ALARM_TYPES.WARNING;
    }
  }

  if (alarm.tag) {
    const tagStr = String(alarm.tag).toLowerCase();
    if (ALERT_TYPE_VALUES.includes(tagStr as any)) {
      return ALARM_TYPES.ALERT;
    }
  }

  if (alarm.severity) {
    const severityStr = String(alarm.severity).toLowerCase();
    if (ALERT_SEVERITY_VALUES.includes(severityStr as any)) {
      return ALARM_TYPES.ALERT;
    }
  }

  return ALARM_TYPES.WARNING;
};

export const orderAlarmsData = (data: AlarmData[]): AlarmData[] => {
  return data
    .sort((a, b) => {
      const orderA =
        ALARM_TYPE_ORDER[a.type as keyof typeof ALARM_TYPE_ORDER] ?? 999;
      const orderB =
        ALARM_TYPE_ORDER[b.type as keyof typeof ALARM_TYPE_ORDER] ?? 999;
      return orderA - orderB;
    })
    .sort((a, b) => {
      const ackA = a?.acknowledged ? 1 : -1;
      const ackB = b?.acknowledged ? 1 : -1;
      return ackA - ackB;
    });
};
